import { faSearch, faTimes } from "@fortawesome/pro-regular-svg-icons";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import { IconButton } from "@aviary/components/Button/IconButton";
import { useDropdownContext } from "@aviary/components/Dropdown/DropdownContext";
import { TextField, type TextFieldProps } from "@aviary/components/TextField";
import { l } from "@aviary/locales/i18n";
import type { AviaryColorProps } from "@aviary/types/aviaryColors";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { FontAwesomeIcon } from "@shared/react-fontawesome";

import { DropdownHeader } from "../../DropdownHeader";

import * as styles from "./DeprecatedDropdownSearch.styles";

interface Props extends AviaryColorProps, TextFieldProps {
  onCancel: (event: ChangeEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const DeprecatedDropdownSearch = ({ value, onCancel, ...rest }: Props) => {
  const { isFullWidth } = useDropdownContext();
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const handleCancel = () => {
    onCancel({ target: { value: "" } } as ChangeEvent<HTMLInputElement>);
  };

  const isEmpty = !value;

  const cancelIconStyle = [styles.cancelIcon.base, isEmpty && styles.cancelIcon.hidden];

  const dropDownSearchStyle = [styles.dropdownSearch.base, isEmpty && styles.dropdownSearch.empty];

  return (
    <DropdownHeader noStyle {...rest} showDivider={false}>
      <div css={dropDownSearchStyle}>
        <FontAwesomeIcon css={styles.searchIcon} icon={faSearch} />
        <TextField
          type="text"
          css={[styles.input.base, isFullWidth && styles.input.fullWidth]}
          value={value}
          isFocused={tablet.greaterThan}
          aria-label={t(l.aviary.searchBar.Search)}
          {...rest}
        />
        <IconButton
          isColor="system"
          isIcon
          aria-label={t(l.aviary.common.clear)}
          isCircular
          isText
          css={cancelIconStyle}
          onClick={handleCancel}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </div>
    </DropdownHeader>
  );
};

export { DeprecatedDropdownSearch };
